function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Coverage = function Coverage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M12.851 1.038c.86.107 1.644.375 2.403.634l.326.11a23.7 23.7 0 0 1 4.445 1.998c1.438.844 2.3 1.7 2.451 3.576.027.336.03.684.006 1.064a58 58 0 0 1-.809 6.83c-.385 2.117-1.963 3.54-3.457 4.654-1.728 1.289-3.21 2.207-4.632 2.867l-.328.148a2.4 2.4 0 0 1-.958.202 2.5 2.5 0 0 1-1.064-.237c-1.86-.761-3.53-1.953-4.952-3.013-1.494-1.113-3.072-2.537-3.457-4.653a57 57 0 0 1-.809-6.831 7.5 7.5 0 0 1 .006-1.064c.151-1.875 1.013-2.731 2.451-3.575 1.62-.951 3.43-1.726 5.38-2.302.871-.258 1.857-.551 2.998-.408m-2.43 2.326c-1.795.53-3.455 1.239-4.936 2.108-1.047.615-1.386.973-1.47 2.012a5.5 5.5 0 0 0-.003.782 56 56 0 0 0 .781 6.595c.26 1.432 1.503 2.526 2.684 3.407 1.33.992 2.888 2.106 4.543 2.776a1 1 0 0 1 .111.053c.005 0 .16.062.32-.01 1.381-.605 2.833-1.491 4.57-2.787 1.181-.88 2.423-1.974 2.684-3.407.383-2.103.645-4.321.781-6.593a5.5 5.5 0 0 0-.003-.783c-.084-1.04-.423-1.398-1.47-2.012a21.8 21.8 0 0 0-4.07-1.826l-.335-.114c-.694-.237-1.35-.461-2.005-.543-.724-.09-1.433.12-2.183.342m5.873 5.653a1 1 0 0 1-.006 1.414l-4.316 4.28a1 1 0 0 1-.704.29h-.007a1 1 0 0 1-.705-.298l-2.302-2.338a1 1 0 0 1 1.425-1.404l1.597 1.623L14.88 9.01a1 1 0 0 1 1.414.006"
  }));
};
export default Coverage;